module.exports = __webpack_public_path__ + "static/profile-3c6200d836b8315c15c8ca35cfeec0fe.png";